import { z } from 'zod/v4';

export const DeleteUserCompanyParamsSchema = z.object({
  id: z.string().min(1, 'User company ID is required'),
});

export type DeleteUserCompanyParams = z.infer<
  typeof DeleteUserCompanyParamsSchema
>;
